import { ModulesMap } from '@/config/data/modulesMaps'
import ApiModule from '@/services/apiModule.js'

export default class WorksProductivityNormsApi extends ApiModule {
	constructor() {
		super(ModulesMap.WORKS_PRODUCTIVITY_NORMS, {
			entity: 'works_productivity_norms',
		})
	}
}
